<template>
  <div class="col-12 row bdr-l-primary-lg q-px-md q-py-sm bg-grey-2">
    <div class="col-6 col-shrink q-pr-sm column">
      <div>
        <span class="text-title text-weight-medium text-grey-10">
          {{ onRoadCost | currency }}
        </span>
        <span class="text-tab text-grey-6">inc. of gst</span>
      </div>
      <span class="q-pt-xs">Car drive away price</span>
    </div>
    <div class="row col-6" v-if="rrpSaving">
      <QImg
        basic
        contain
        :src="img"
        v-if="img"
        width="14px"
        position="0 0"
        class="q-mr-sm"
      />
      <span class="text-primary-semi-light q-pt-xs col">
        You save {{ rrpSaving | currency }} off the RRP
      </span>
    </div>
  </div>
</template>

<script>
import { QImg } from 'quasar';

export default {
  name: 'CarPriceCard',
  props: {
    onRoadCost: Number,
    rrpSaving: Number,
    img: String
  },
  components: {
    QImg
  }
};
</script>
